import { useCallback, useLayoutEffect, useState } from 'react';

function useOverflowDetection(ref: React.RefObject<HTMLDivElement>): { xOverflowing: boolean; yOverflowing: boolean } {
  const [overflow, setOverflow] = useState({ xOverflowing: false, yOverflowing: false });

  const checkOverflow = useCallback(() => {
    if (ref.current) {
      const { scrollWidth, clientWidth, scrollHeight, clientHeight } = ref.current;
      const xOverflowing = scrollWidth > clientWidth;
      const yOverflowing = scrollHeight > clientHeight;
      setOverflow({ xOverflowing, yOverflowing });
    }
  }, [ref]);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    checkOverflow();

    const resizeObserver = new ResizeObserver(checkOverflow);
    resizeObserver.observe(element);

    return () => resizeObserver.unobserve(element);
  }, [ref, checkOverflow]);

  return { xOverflowing: overflow.xOverflowing, yOverflowing: overflow.yOverflowing };
}

export default useOverflowDetection;
